<template>
  <div
    class="nav relief-nav-bar"
    :style="{ height: height + 'rem', 'box-shadow': navboxshadow }"
  >
    <div
      class="return-btn"
      v-show="lefticonshow"
      @click="goback"
      :style="{ height: lefticonheight + 'rem', width: lefticonwidth + 'rem' }"
    >
      <img :src="lefticon" alt="" />
    </div>
    <div
      class="nav-title"
      :style="{
        height: height + 'rem',
        'line-height': height + 'rem',
        'font-size': fontsize,
        'font-weight': fontweight,
        color: titlecolor,
      }"
    >
      <span>{{ title || titletext }}</span>
    </div>
    <div class="collect-btn" v-show="righttwoiconshow" @click="righttwoclick">
      <img :src="righttwoicon" alt="" />
    </div>
    <div class="share-btn" @click="rightclick" v-show="righticonshow">
      <img v-show="righticon" :src="righticon" alt="" />
      <p class="righttext" v-show="righttext" :style="righttextStyle">
        {{ righttext }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    navboxshadow: {
      type: String,
      default: "",
    },
    height: {
      type: Number,
      default: 4.4,
    },
    title: {
      type: String,
      default: "",
    },
    lefticon: {
      type: String,
      default: "",
    },
    lefticonshow: {
      type: Boolean,
      default: true,
    },
    righttwoicon: {
      type: String,
      default: "",
    },
    righttwoiconshow: {
      type: Boolean,
      default: false,
    },
    righticon: {
      type: String,
      default: "",
    },
    righticonshow: {
      type: Boolean,
      default: false,
    },
    righttextStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    lefticonheight: {
      type: Number,
      default: 3.2,
    },
    lefticonwidth: {
      type: Number,
      default: 3.2,
    },
    fontsize: {
      type: String,
      default: "1.6rem",
    },
    fontweight: {
      type: Number,
      default: 400,
    },
    titlecolor: {
      type: String,
      default: "#333333",
    },
    righttext: {
      type: String,
      default: "",
    },
    titletext: {
      type: String,
      default: "",
    },
  },
  methods: {
    goback() {
      this.$emit("goback");
    },
    righttwoclick() {
      this.$emit("righttwoclick");
    },
    rightclick() {
      this.$emit("rightclick");
    },
  },
};
</script>
<style scoped lang='less'>
.nav {
  position: relative;
  top: 0;
  width: 100%;
  z-index: 9;

  .nav-title,
  .return-btn,
  .collect-btn,
  .share-btn {
    width: 3.2rem;
    height: 3.2rem;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
  }

  .nav-title {
    left: 0;
    width: 100%;
    text-align: center;
    z-index: 1;
  }

  .nav-title span {
    display: inline-block;
    width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .return-btn {
    left: 1.2rem;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .share-btn {
    text-align: center;
    right: 1.2rem;

    img {
      // width: 100%;
      // height: 100%;
      width: 1.6rem;
      height: 1.6rem;
    }
  }

  .collect-btn {
    right: 7.2rem;
  }

  img {
    width: 3.2rem;
    height: 3.2rem;
  }

  .righttext {
    font-size: 1rem;
    color: #fff;
    font-weight: 400;
  }
}
</style>